'use client';
import Image from '@repo/ui/src/components/Image';
import { Anchor } from '@repo/ui/src/components/Anchor';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { cTAClicked, productClicked } from '@repo/ui/src/services/analytics';
import { basketLineInputToAnalytics } from '@repo/ui/src/services/analytics/factories';
import { LineItem } from '@repo/ui/src/types/lineItem';
import { OrderRowBodyProps } from '@views/Account/OrderRowBody';
import React from 'react';

export interface OrderLineItemProps extends Omit<
  OrderRowBodyProps,
  'giftCardLink' | 'giftCertificateItems' | 'getCurrencyString' | 'productItems'
> {
  lineItem: LineItem;
  index: number;
}

const OrderLineItem = ({
  lineItem,
  index,
  quantityText,
  reviewLinkText,
  hideReviewLink = false,
  isAccountPage = false,
}: OrderLineItemProps) => {
  const { locale } = useCurrentUrl();
  const lineItemImage = lineItem?.image;
  return (
    <li className="bg-white grid grid-cols-[auto_1fr] items-center p-4 md:py-5 md:px-6 gap-4 md:gap-10">
      {lineItemImage ? (
        <Image
          src={lineItemImage}
          width={100}
          height={100}
          objectFit="contain"
          alt={lineItem.title}
        />
      ) : (
        <div className="w-[100px] aspect-square bg-warm-200 rounded-sm" />
      )}
      <div className="md:flex md:flex-row w-full md:justify-between gap-x-4">
        <div>
          {lineItem.productUrl ? (
            <Anchor
              link={lineItem.productUrl}
              className="tra-text-web-body-m-link font-bold"
              onClick={() => {
                productClicked({
                  affiliation: 'website',
                  locale,
                  brand: 'Traeger',
                  basket_token: '',
                  currency: '',
                  ...basketLineInputToAnalytics(lineItem, index),
                });
              }}
            >
              {lineItem.title}
            </Anchor>
          ) : (
            <p className="tra-text-web-body-m font-bold">{lineItem.title}</p>
          )}
          <p className="my-2 md:mt-3 tra-text-web-body-m">
            {quantityText} {lineItem.quantity}
          </p>
        </div>
        <div className="flex gap-3 md:flex-col">
          {!hideReviewLink && lineItem.sku && (
            <button
              className="tra-text-web-body-m-link"
              onClick={() => {
                window.$BV.ui('rr', 'submit_review', { productId: lineItem.sku });
                cTAClicked({
                  affiliation: 'website',
                  brand: 'Traeger',
                  locale,
                  cta_location: isAccountPage ? 'my account_order history' : 'order_tracking',
                  cta_text: reviewLinkText,
                  cta_type: 'button',
                });
              }}
            >
              {reviewLinkText}
            </button>
          )}
        </div>
      </div>
    </li>
  );
};

export default OrderLineItem;
